// extracted by mini-css-extract-plugin
export default {"selector":"drugClassSelector_selector__yJPWF","option":"drugClassSelector_option__g7GtB"};